import API from 'utils/api';
import { onError } from 'utils/handlers';
import { updateEntidadInfo } from 'store/auth';
import getFormattedValues, { hasFiles } from 'utils/formatValues';

export const baseURL = '/estructura-organizacional/entidades/';

const getValuesAndConfig = (values) => {
  const files = ['logotipo'];
  const config = hasFiles(values, files) ? {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  } : {};
  const formattedValues = getFormattedValues(values, {
    files,
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Entidad
 */
export const getEntidad = async (dispatch) => {
  try {
    const response = await API.get(baseURL);
    if (dispatch) {
      dispatch(updateEntidadInfo(response.data));
    }
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * PATCH Entidad
 * @param {object} values
 */
export const patchEntidad = async (values) => {
  try {
    const response = await API.patch(baseURL, ...getValuesAndConfig(values));
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Entidad
 * @param {object} values
 */
export const postEntidad = async (values) => {
  try {
    const response = await API.post(baseURL, ...getValuesAndConfig(values));
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};
